module.exports = __webpack_public_path__ + "static/media/zoom.26b15391.svg";